import React, { FC, useState, useEffect } from 'react'

import Modal from '../../common/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-common-types'
import { SettingMember } from '../../../../states/types/setting'

interface InvitationModalState {
  display: boolean,
  targetMemberList: SettingMember[]
}

interface Props {
  invitationModalState: InvitationModalState
  invitationCallback: (memberIds: number[]) => void
  closeCallback: VoidFunction
  closeable?: boolean
}

const InvitationModal: FC<Props> = (props) => {
  const {
    invitationModalState,
    invitationCallback,
    closeCallback,
    closeable,
  } = props

  const [displayModal, setDisplayModal] = useState<boolean>(false)
  const [data, setData] = useState<{id: number, name: string, kana: string | null, email: string, checked: boolean}[]>([])

  const invitation = () => {
    invitationCallback(data.filter((v) => v.checked).map((v) => v.id))
  }

  const toggleInvitation = (id: number) => {
    setData(data.map((v) => (v.id === id ? { ...v, checked: !v.checked } : v)))
  }

  const changeCheckBox = (type: string) => {
    if (type === "allCheck") {
      setData(data.map((v) => ({ ...v, checked: true })))
      return
    }
    if (type === "allUncheck") {
      setData(data.map((v) => ({ ...v, checked: false })))
    }
  }

  useEffect(() => {
    setDisplayModal(invitationModalState.display)
  }, [invitationModalState.display])

  useEffect(() => {
    if (!displayModal) return
    setData(invitationModalState.targetMemberList.map((v) => ({
      id: v.id,
      name: v.name,
      kana: v.kana,
      email: v.email,
      checked: true,
    })))
  }, [displayModal])

  return (
    <Modal
      title="招待メールを送信"
      show={displayModal}
      wrapperClass="setting_member"
      closeCallback={closeCallback}
      closeable={closeable}
    >
      <>
        {
          data.length ? (
            <>
              <div
                style={{
                  marginBottom: "8px",
                }}
              >
                未ログインのユーザーに招待メールを送信することができます
              </div>
              <div
                style={{
                  marginBottom: "8px",
                }}
              >
                招待メールを送信したいユーザーを選択して、送信ボタンを押してください
              </div>
              <div
                style={{
                  marginBottom: "8px",
                  display: "flex",
                  gap: "8px",
                }}
              >
                <button
                  type="button"
                  onClick={() => changeCheckBox("allUncheck")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    borderRadius: "20px",
                    backgroundColor: "#EEEEEE",
                    color: "#666666",
                  }}
                >
                  <FontAwesomeIcon
                    icon={['far', 'square']}
                    className="icon no_check"
                    fixedWidth
                    style={{
                      fontSize: "18px",
                      color: "#666666",
                    }}
                  />
                  すべての選択を外す
                </button>
                <button
                  type="button"
                  onClick={() => changeCheckBox("allCheck")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    borderRadius: "20px",
                    backgroundColor: "#deffde",
                    color: "#008800",
                  }}
                >
                  <FontAwesomeIcon
                    icon={['far', 'check-square']}
                    className="icon checked"
                    fixedWidth
                    style={{
                      fontSize: "18px",
                      color: "#008800",
                    }}
                  />
                  すべて選択する
                </button>
              </div>
              <div
                style={{
                  border: "solid 1px #999",
                  borderRadius: "4px",
                  padding: "8px",
                  display: "flex",
                  flexFlow: "column",
                  gap: "2px",
                  maxHeight: "300px",
                  overflowY: "scroll",
                }}
              >
                {
                  data.map((v) => (
                    <div
                      key={`invitation_${v.id}`}
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                        cursor: "pointer",
                        backgroundColor: v.checked ? "transparent" : "#EEEEEE",
                        padding: "4px",
                      }}
                      onClick={() => toggleInvitation(v.id)}
                      role="none"
                    >
                      <div
                        style={{
                          width: "24px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={['far', `${v.checked ? 'check-square' : 'square'}` as IconName]}
                          className={`icon ${v.checked ? "checked" : "no_check"}`}
                          fixedWidth
                          style={{
                            fontSize: "18px",
                            color: v.checked ? "#008800" : "#666666",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "calc(50% - 24px)",
                        }}
                      >
                        <ruby>
                          {v.name}
                          <rt>{v.kana}</rt>
                        </ruby>
                      </div>
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        {v.email}
                      </div>
                    </div>
                  ))
                }
              </div>
            </>
          ) : (
            <>
              送信対象のユーザーがいません
            </>
          )
        }
      </>
      <>
        <button type="button" className="button cancel" onClick={closeCallback} disabled={!closeable}>
          キャンセル
        </button>
        <button
          type="button"
          className="button"
          onClick={invitation}
          disabled={!data.filter((v) => v.checked).length}
        >
          送信する
        </button>
      </>
    </Modal>
  )
}

InvitationModal.defaultProps = {
  closeable: undefined,
}

export default InvitationModal
